<header class="header bg-surface border-b">
  <div class="header-container d-flex items-center justify-between gap-4">
    <!-- Mobile: Logo top-left -->
    <a
      routerLink="/home"
      class="header__logo header__logo--mobile"
      aria-label="Home">
      <img
        [src]="_logoFilename | assetUrl"
        alt=""
        width="104"
        height="42"
        class="header__logo-image"
        loading="eager" />
    </a>

    <!-- Desktop: Panel-left icon (top-left, hidden on mobile) -->
    <div class="header__desktop-menu-trigger">
      @if (sidebarEnabled()) {
        <button
          type="button"
          class="header__menu-trigger"
          [attr.aria-label]="sidebarOpen() ? 'Close menu' : 'Open menu'"
          (click)="_onMenuToggle()">
          <app-layout-icon
            [icon]="sidebarOpen() ? 'panel-left-close' : 'panel-left-open'"
            size="md" />
        </button>
      }
      <img
        [src]="_logoFilename | assetUrl"
        alt="Educational Initiatives"
        width="130"
        height="42"
        class="sidebar__logo-image"
        loading="eager" />
    </div>

    <!-- Actions: apps, profile, logout -->
    <div class="header-actions d-flex flex-row items-center gap-2">
      @if (_userInfo()) {
        <app-palette />
        <app-user-profile
          [compact]="true"
          [manageAccountUrl]="manageAccountUrl()" />
        <button
          type="button"
          class="header__logout"
          data-test-id="header-logout"
          [disabled]="_isLoggingOut()"
          [attr.aria-label]="'auth.logout' | transloco"
          (click)="_onLogout()">
          <app-layout-icon icon="logout" size="sm" />
          <span class="header__logout-label">{{
            _isLoggingOut()
              ? ('auth.loggingOut' | transloco)
              : ('auth.logout' | transloco)
          }}</span>
        </button>
      }
      <ng-content />
    </div>
  </div>
</header>
